export enum ResponseKind {
  Success = "success",
  NoData = "no_data",
  LowSampleSize = "low_sample_size",
}

const NO_DATA_MESSAGE =
  "This feature is disabled due to missing or un-submitted data. To unlock this feature and drive growth for your business, please contact your Account Manager.";
const LOW_SAMPLE_SIZE_MESSAGE = "Signal insufficient, please contact your Account Manager";

const OVERLAY_MESSAGES: Record<ResponseKind, string> = {
  [ResponseKind.NoData]: NO_DATA_MESSAGE,
  [ResponseKind.LowSampleSize]: LOW_SAMPLE_SIZE_MESSAGE,
  [ResponseKind.Success]: "",
};

export const overlayMessage = (kind: ResponseKind) => OVERLAY_MESSAGES[kind];

const HAS_DATA: Record<ResponseKind, boolean> = {
  [ResponseKind.Success]: true,
  [ResponseKind.NoData]: false,
  [ResponseKind.LowSampleSize]: false,
};

export const responseHasData = (kind: ResponseKind) => HAS_DATA[kind];
